import { contactTypes } from "../lib/constants";
import { userTypes } from "./constants";

const calculatePercentage = (value, percentages) => {
  if (value === null || value === undefined || value === "" || value < 0) {
    return "N/A";
  }
  return value === 0 ? 0 : Math.min(percentages[value - 1] || 100, 100);
};

const hasLeaguePhoneAccess = (contact, user) => {
  if (!contact?.phone) return false;
  if (contact?.type !== contactTypes.LEAGUE) return true;
  if (user?.userType === userTypes.AGENT) return false;
  if (user?.userType === userTypes.PLAYER && contact?.teamId === user?.teamId)
    return true;
  if (user?.userType === userTypes.COLLEGE && contact?.teamId === user?.teamId)
    return false;
  if (user?.userType === userTypes.EXECUTIVE) return true;
  if (user?.userType === userTypes.COACH) return true;
  if (user?.userType === userTypes.PARENT) return false;
  if (user?.userType === userTypes.SPOUSE) return false;
  if (user?.userType === userTypes.REPORTER) return false;

  return false;
};
const hasLeagueEmailAccess = (contact, user) => {
  if (!contact?.email) return false;
  if (contact?.type !== contactTypes.LEAGUE) return true;
  if (user?.userType === userTypes.AGENT) return true;
  if (user?.userType === userTypes.PLAYER && contact?.teamId === user?.teamId)
    return true;
  if (user?.userType === userTypes.COLLEGE && contact?.teamId === user?.teamId)
    return true;
  if (user?.userType === userTypes.EXECUTIVE) return true;
  if (user?.userType === userTypes.COACH) return true;
  if (user?.userType === userTypes.PARENT) return false;
  if (user?.userType === userTypes.SPOUSE) return false;
  if (user?.userType === userTypes.REPORTER) return true;

  return false;
};

export { calculatePercentage, hasLeagueEmailAccess, hasLeaguePhoneAccess };
